import React from 'react';
import { observer } from 'mobx-react';
import ErrorBoundary from 'components/hoc/error_boundary.js';
import styled from '@emotion/styled';
import { ExerciseUI, AppUI } from '@seedlang/state';
import Button from 'components/button/button';
import { CrownIcon } from '@seedlang/icons';
import Link from 'components/link';
import Text from 'components/text';
import eventParamsHelper from 'utils/event_params_helper';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin: ${props => props.margin};
  .fa {
    margin-right: 10px;
  }
`;

@observer
class NoAccessButton extends React.Component {

  static defaultProps = {
    margin: '50px 0 30px 0',
    borderRadius: '25px',
    height: '50px',
    fontSize: '16px',
  };

  get message() {
    if (this.props.message) {
      return this.props.message;
    }
    switch (this.props.reason) {
      case 'create_free_account':
        return 'Create Free Account to Try';
      case 'migrate':
        return 'Switch Payment to our Platform';
      case 'upgrade':
        return 'Upgrade to Unlock';
      case 'become_a_member':
      default:
        return 'Become a Member to Unlock';
    }
  }
  get destinationRouteName() {
    switch (this.props.reason) {
      case 'create_free_account':
        return 'onboarding.register';
      case 'migrate':
        return 'settings.billing';
      default:
        return 'memberships.index';
    }
  }
  onClick = () => {
    if (AppUI.siteIsMemrev) {
      AppUI.createEvent('memrev - click no access button', eventParamsHelper({
        source: 'no_access_button',
        button_text: this.message,
        reason: this.props.reason || 'become_a_member',
        source_route: AppUI.routeStore.routeName,
        source_path: window.location.pathname,
        destination_route: this.destinationRouteName,
      }));
    }

    ExerciseUI.routeStore.routeToNamed(this.destinationRouteName);
  }

  render() {
    return (
      <Wrapper
        margin={this.props.margin}
      >
        <Button
          background={ExerciseUI.site.headerButtonColor}
          backgroundOnActive={ExerciseUI.site.accentColor}
          backgroundOnHover={ExerciseUI.site.transparentAccentColor}
          color='white'
          onClick={this.onClick}
          fontSize={this.props.fontSize}
          height={this.props.height}
          width={this.props.width}
          scaleOnHover={1.02}
          scaleOnActive={1}
          borderRadius={this.props.borderRadius}
        >
          {this.props.reason === 'upgrade' && <i className='fa fa-lock'/>}
          {!['create_free_account', 'upgrade'].includes(this.props.reason) && <CrownIcon margin='0 5px 0 0'/>}
          {this.message}
        </Button>
        {
          this.props.subText &&
            <Text fontSize={14} lineHeight={16} fontWeight='bold' color='#777' center margin='20px 0 0 0' maxWidth='600px' wrap='balance'>
              {this.props.subText}
            </Text>
        }
        {
          !AppUI.userIsSignedInAndNotGuest &&
            <Link className='underline' to='onboarding.sign_in'>
              <Text fontSize={10} color='#333'>
                {this.props.reason === 'create_free_account' 
                  ? 'Already have an Account? Sign in' 
                  : 'Already a Member? Sign in'
                }
              </Text>
            </Link>
        }
      </Wrapper>
    );
  }
}

export default ErrorBoundary(NoAccessButton);
